import { useRef } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { useShareAction } from 'app/shared/hooks/useShareAction';
import { useListingSaveActions } from '../../../../hooks';
import { useListingCTAs } from '../../../../hooks/useListingCTAs';
import { Button } from '../../../ui/Button';
import { FavoriteButton, ShareButton } from '../SocialActions';
import { actionLabel, actionWithLabel } from '../../../../pages/HaloListingPage/desktopStickyHeader.styles';

type ListingHeaderActionsProps = {
  size?: 'sm' | 'md';
  showCTAs?: boolean;
};

export const ListingHeaderActions = ({ size, showCTAs }: ListingHeaderActionsProps) => {
  const favoriteButtonRef = useRef<HTMLButtonElement>(null);
  const { listingSaved, toggleSave } = useListingSaveActions(favoriteButtonRef);
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const openShare = useShareAction({
    listing: listing as unknown as ListingDetails,
    triggerLocation: 'home_details',
    triggerObject: 'home_details_component|action_bar',
  });
  const { ctas, overlays } = useListingCTAs();
  const headerCTAs = showCTAs ? ctas.filter((c) => c.id !== 'apply') : [];

  return (
    <>
      {headerCTAs.map((cta) => (
        <div key={cta.id} className={actionWithLabel} title={cta.label}>
          <Button
            shape="circle"
            tone="neutral"
            emphasis="outlined"
            size="sm"
            onClick={cta.onClick}
            aria-label={cta.ariaLabel}
          >
            {cta.icon}
          </Button>
          <span className={actionLabel}>{cta.label}</span>
        </div>
      ))}
      <ShareButton onClick={openShare} aria-label="Share this listing" size={size} />
      <FavoriteButton
        ref={favoriteButtonRef}
        onClick={toggleSave}
        isSaved={listingSaved}
        aria-label={listingSaved ? 'Remove from saved listings' : 'Save this listing'}
        size={size}
      />
      {showCTAs && overlays}
    </>
  );
};
